import { PermissionValues as Permissions } from '@gripp/shared-logic';
import { routinesPaths } from '../routinesPaths';
import { RoutinePrintPage } from './routinePrintPage';

/**
 * Sits above the `routines/*` catch-all: React Router v6 ranks a route by
 * segment specificity, not declaration order, so the static `print` segment
 * wins over the splat.
 *
 * Gated on `asset.read` -- the same permission as the routine-execution route
 * this page is opened from, which renders the same routine from a URL-supplied
 * id under the same gate.
 *
 * That parity is all this gate buys. The backing `getWorkspaceRoutine` is a
 * generated read whose only check is an unqualified `workspaceroutine.read`,
 * which every seeded role holds, so it resolves any id regardless of the
 * caller's workspace. Scoping it belongs in the resolver, not here: a check in
 * this route would not constrain a direct call to the API.
 */
export const routinePrintRoutes = [
  {
    path: `${routinesPaths.root}/print/:routineId`,
    element: <RoutinePrintPage />,
    handle: {
      header: {
        titleKey: 'assets.list.routines',
        icon: 'printer',
      },
      requiredPermission: Permissions.asset.read,
    },
  },
];
